import { render, staticRenderFns } from "./IMMessageIcon.vue?vue&type=template&id=d2513fa6&scoped=true"
import script from "./IMMessageIcon.vue?vue&type=script&lang=js"
export * from "./IMMessageIcon.vue?vue&type=script&lang=js"
import style0 from "./IMMessageIcon.vue?vue&type=style&index=0&id=d2513fa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2513fa6",
  null
  
)

export default component.exports